import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="centered-message">Validando sessão...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
